import * as St from './WarningModal.styles';

import CommonButton from '~atoms/CommonButton';

export type WarningModalProps = {
  title: string;
  description: string;
  buttons: {
    cancel: string;
    confirm: string;
  };
  isVisible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const WarningModal = ({
  title,
  description,
  buttons,
  isVisible,
  onCancel,
  onConfirm,
  ...props
}: WarningModalProps) => (
  <St.Container
    {...props}
    type="warning"
    title={title}
    content={description}
    isVisible={isVisible}
    onClose={onCancel}
    footer={[
      <CommonButton
        key="back"
        onClick={onCancel}
        data-style="warning-secondary"
      >
        {buttons.cancel}
      </CommonButton>,
      <CommonButton
        key="submit"
        onClick={onConfirm}
        data-style="warning-primary"
      >
        {buttons.confirm}
      </CommonButton>,
    ]}
  />
);

export default WarningModal;
